<div class="tariff-feature">
  <h4 class="tariff-feature__subtitle">{{ feature.title }}</h4>
  @if (getType(feature.value.premium) === 'string') {
    <p>{{ feature.value.premium }}</p>
    <p>{{ feature.value.expert }}</p>
  }
  @if (getType(feature.value.premium) === 'boolean') {
    <span
      [ngClass]="{ 'btv-icon-circle-success': feature.value.premium, 'btv-icon-circle-close': !feature.value.premium }"
    ></span>
    <span
      [ngClass]="{ 'btv-icon-circle-success': feature.value.expert, 'btv-icon-circle-close': !feature.value.expert }"
    ></span>
  }
</div>
